export default function PHP_xml_set_processing_instruction_handler() {
  return (
    <div>
      <h1>PHP_xml_set_processing_instruction_handler</h1>
    </div>
  );
}
